import React from 'react';
import { Field, Form } from 'formik';
import FormikSelectField from 'components/Fields/FormikSelectField';
import { Button, Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';

const AddPaymentForm = (props) => {
  const { handleSubmit } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="">
        <Row>
          <Col sm={5}>
            <Field
              label="Buyer"
              name="buyer"
              type="select"
              component={FormikSelectField}
              options={[
                { id: 1, label: 'Madhya Pradesh' },
                { id: 2, label: 'Uttar Pradesh' },
              ]}
              defaultoption="Select"
              keys={{ id: 'id', label: 'label' }} //added
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Order Number"
              name="order_number"
              type="select"
              component={FormikSelectField}
              options={[
                { id: 1, label: 'Madhya Pradesh' },
                { id: 2, label: 'Uttar Pradesh' },
              ]}
              defaultoption="Select"
              keys={{ id: 'id', label: 'label' }} //added
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Amount"
              name="amount"
              type="select"
              component={FormikSelectField}
              options={[
                { id: 1, label: 'Madhya Pradesh' },
                { id: 2, label: 'Uttar Pradesh' },
              ]}
              defaultoption="Select"
              keys={{ id: 'id', label: 'label' }} //added
            />
          </Col>
          <Col sm={5}>
            <Field
              label="UTR"
              name="utr"
              type="select"
              component={FormikSelectField}
              options={[
                { id: 1, label: 'India' },
                { id: 2, label: 'USA' },
              ]}
              defaultoption="Select"
              keys={{ id: 'id', label: 'label' }} //added
            />
          </Col>
        </Row>
      </CardWithTitle>

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
        >
          Cancel
        </Button>
        <Button color="warning" size="sm" type="submit" className="mw-100">
          Save
        </Button>
      </div>
    </Form>
  );
};

export default AddPaymentForm;
